import React from 'react';
import { Page } from '../Common/Components/Page';
import { SystemConfigContent } from './Components/SystemConfigContent';

export const SystemConfig = (): React.JSX.Element => (
  <Page title="System Configurations" accessKey={'systemConfig'} isSearchable={false}>
    <SystemConfigContent />
  </Page>
);
